import * as React from 'react';

import './style.scss';

import {P} from 'components/atoms/Text/P';
import {Margin, HeadlineLevel} from 'features/ui/enums';
import {Headline} from '@atoms/Text/Headline';

interface Props {
    areaType: string;
}

export const NoAreaModal: React.FunctionComponent<Props> = ({areaType}) => {
    switch (areaType) {
        case 'bra-i':
            return (
                <div className='no-area-modal'>
                    <Headline level={HeadlineLevel.H2} center margin={Margin.L}>BRA-i</Headline>
                    <P>Fra 01.01.2024 gjelder nye måleregler. BRA-i er internt bruksareal og gjelder alt areal innenfor boligens omsluttende vegger.</P>
                </div>
            );
        case 'bra-e':
            return (
                <div className='no-area-modal'>
                    <Headline level={HeadlineLevel.H2} center margin={Margin.L}>BRA-e</Headline>
                    <P>Fra 01.01.2024 gjelder nye måleregler. BRA-e er eksternt bruksareal utenfor selve boligen. Dette kan for eksempel være sportsbod i kjeller.</P>
                </div>
            );
        case 'bra-b':
            return (
                <div className='no-area-modal'>
                    <Headline level={HeadlineLevel.H2} center margin={Margin.L}>BRA-b</Headline>
                    <P>Fra 01.01.2024 gjelder nye måleregler. BRA-b er bruksareal for innglasset balkong.</P>
                </div>
            );
        case 'bra-total':
            return (
                <div className='no-area-modal'>
                    <Headline level={HeadlineLevel.H2} center margin={Margin.L}>BRA totalt</Headline>
                    <P>Fra 01.01.2024 gjelder nye måleregler. BRA er summen av BRA-i (internt bruksareal), BRA-e (eksternt bruksareal) og BRA-b (innglasset balkong).</P>
                </div>
            );
        case 'tba':
            return (
                <div className='no-area-modal'>
                    <Headline level={HeadlineLevel.H2} center margin={Margin.L}>Terasse- og balkongareal (TBA)</Headline>
                    <P>Fra 01.01.2024 gjelder nye måleregler. TBA angir terrasse og balkongareal som ikke inngår i boligens samlede BRA.</P>
                </div>
            );
    }
    return (
        <div className='no-area-modal'>
            <Headline level={HeadlineLevel.H2} center margin={Margin.L}>Bruksareal</Headline>
            <P>Fra 01.01.2024 gjelder nye måleregler.</P>
            <P><strong>BRA-i</strong><br/> BRA-i er internt bruksareal og gjelder alt areal innenfor boligens omsluttende vegger.</P>
            <P><strong>BRA-e</strong><br/> BRA-e er eksternt bruksareal utenfor selve boligen. Dette kan for eksempel være sportsbod i kjeller.</P>
            <P><strong>BRA-b</strong><br/> BRA-b er bruksareal for innglasset balkong.</P>
            <P><strong>BRA totalt</strong><br/> BRA er summen av BRA-i (internt bruksareal), BRA-e (eksternt bruksareal) og BRA-b (innglasset balkong).</P>
            <P><strong>Terasse- og balkongareal (TBA)</strong><br/> TBA angir terrasse og balkongareal som ikke inngår i boligens samlede BRA.</P>
        </div>
    );
};
